import { FETCH_SEQUENCES, FETCH_SEQUENCES_FAIL, FETCH_SEQUENCE, FETCH_SEQUENCE_FAIL, FETCH_SEQUENCES_LOADING } from './types';
import axios from 'axios';
import { history } from '../components/app';
import { SLACK_WEBHOOKS, CYOA_NETWORK_IDS } from '../config';
import { SlackWebhook } from './utils';

/**
 * Fetch sequences via Busabout API (Only for getting slider data)
 *
 * @param {number} style - travel style (1,2,3).
 * @param {number} optionals - optionals node (0,1,2).
 * @param {string} city - start city.
 * @param {number} currency - currency (GBP, AUD, USD, CAD).
 * @param {number} stops - number of stops.
 * @param {number} days - number of days.
 * @param {bundle} bundle - bundle on or off
 * @param {custom} custom - custom search
 * @param {String} tourID - The ID of the tour (europe / USA)
 */
export function FetchSequences(style, optionals, city, currency, stops=null, days=null, bundle=null, custom=null, tourID = CYOA_NETWORK_IDS["europe"].id){

  const HAS_STYLE = (style !== null && style !== undefined) ? `&style=${style}` : "";
  const HAS_OPTIONALS = (optionals !== null && optionals !== undefined) ? `&optionals=${optionals}` : "";
  const HAS_CITY = (city !== null && city !== undefined) ? `&city=${city}` : "";
  const HAS_STOPS = (stops !== null) ? `&stops=${stops}` : "";
  const HAS_DAYS = (days !== null) ? `&days=${days}` : "";
  const HAS_BUNDLE = (bundle !== null) ? `&bundle=${bundle}` : "";
  const HAS_CUSTOM = (custom !== null) ? `&custom=${custom}` : "";
  const SEQUENCE_URL = `${process.env.REACT_APP_NETWORK_API}${tourID}/sequences?api_token=${process.env.REACT_APP_API_TOKEN}&currency=${currency}${HAS_STYLE}${HAS_OPTIONALS}${HAS_CITY}${HAS_STOPS}${HAS_DAYS}${HAS_BUNDLE}${HAS_CUSTOM}`;

  return async dispatch => {
    dispatch({type:FETCH_SEQUENCES_LOADING, payload:true});
    try{
      const data = await axios.get(SEQUENCE_URL);
      dispatch({type:FETCH_SEQUENCES, payload:data});
    }
    catch(err){
      dispatch({type:FETCH_SEQUENCES_FAIL});
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Discovery page - SEQUENCE API (GET) - '  + SEQUENCE_URL + " " + err}));
      console.error(err);
      history.push('/500');
    }
  }
}


/**
 * Fetch single sequence via Busabout API
 *
 * @param {String} sequenceID - MD5 hash
 * @param {number} style - travel style (1,2,3).
 * @param {number} optionals - optionals node (0,1,2).
 * @param {string} city - start city.
 * @param {number} currency - currency (GBP, AUD, USD, CAD).
 * @param {number} stops - number of stops.
 * @param {number} days - number of days.
 * @param {String} tourID - The ID of the tour (europe / USA)
 */
export function FetchSequence(sequenceID, style, optionals, city, currency, stops=null, days=null, bundle=null, custom=null, tourID = CYOA_NETWORK_IDS["europe"].id){

  const HAS_STYLE = (style !== null && style !== undefined) ? `&style=${style}` : "";
  const HAS_OPTIONALS = (optionals !== null && optionals !== undefined) ? `&optionals=${optionals}` : "";
  const HAS_CITY = (city !== null && city !== undefined) ? `&city=${city}` : "";
  const HAS_STOPS = (stops !== null && stops !== undefined) ? `&stops=${stops}` : "";
  const HAS_DAYS = (days !== null && days !== undefined) ? `&days=${days}` : "";
  const HAS_BUNDLE = (bundle !== null) ? `&bundle=${bundle}` : "";
  const HAS_CUSTOM = (custom !== null) ? `&custom=${custom}` : "";
  const SEQUENCE_URL = `${process.env.REACT_APP_NETWORK_API}${tourID}/sequences/${sequenceID}?api_token=${process.env.REACT_APP_API_TOKEN}&currency=${currency}${HAS_STYLE}${HAS_OPTIONALS}${HAS_CITY}${HAS_STOPS}${HAS_DAYS}${HAS_BUNDLE}${HAS_CUSTOM}`;

  return async dispatch => {
    try{
      const data = await axios.get(SEQUENCE_URL);
      dispatch({type:FETCH_SEQUENCE, payload:data});
    }
    catch(err){
      dispatch({type:FETCH_SEQUENCE_FAIL});
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Discovery pages - SEQUENCE API (GET) - '  + SEQUENCE_URL + " " + err}));
      console.error(err);
      history.push('/500');
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/sequence.js